<div class="modal-header">
  <h5 class="modal-title"><i class="fal fa-comments"></i> {{ data ? 'Edit' : 'Add' }} Interaction</h5>
  <button (click)="close()" type="button" class="close" aria-label="Close">
    <i class="fas fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form" [formEditablePermission]="form">
    <div class="row">
      <div class="col-md-6">
        <mat-form-field class="mat-block">
          <mat-select formControlName="type" placeholder="Interaction Type" required>
            <mat-option *ngFor="let type of types" [value]="type.value">{{ type.name }}</mat-option>
          </mat-select>
          <mat-error *ngIf="form.get('type').touched && form.get('type').hasError('required')">
            Type is <strong>required</strong>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field class="mat-block">
          <input
            matInput
            required
            [min]="minDateDefault"
            [max]="maxDateDefault"
            [matDatepicker]="date"
            placeholder="Date:"
            (focus)="date.open()"
            formControlName="date"
            readonly
          />
          <mat-datepicker-toggle matSuffix [for]="date"></mat-datepicker-toggle>
          <mat-datepicker #date></mat-datepicker>
          <mat-error *ngIf="form.get('date').touched && form.get('date').hasError('required')">
            Date is <strong>required</strong>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-12">
        <mat-form-field class="mat-block mat-txt-area" appearance="outline">
          <textarea
            matInput
            #comment
            maxlength="500"
            rows="14"
            formControlName="comment"
            required
            placeholder="Type your comment here.."
          ></textarea>
          <mat-hint align="end">{{ form.get('comment').value?.length || 0 }}/500</mat-hint>
          <mat-error *ngIf="form.get('comment').touched && form.get('comment').hasError('required')">
            Comment is <strong>required</strong>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button
    *ngIf="data"
    (click)="delete()"
    [disabled]="1 | isReadonlyRole"
    type="button"
    class="btn btn-danger text-uppercase"
  >
    <i class="fal fa-trash-alt"></i> delete
  </button>
  <button (click)="close()" type="button" class="btn btn-outline btn-default-outline text-uppercase">
    <i class="fal fa-times"></i> cancel
  </button>
  <button
    (click)="save(form)"
    type="button"
    [disabled]="1 | isReadonlyRole"
    class="btn btn-success text-uppercase create-btn"
  >
    <i class="fal fa-save"></i> save
  </button>
</div>
